import { computed } from 'vue'
import { is } from 'ramda'
import { PARTNER_APP_INTEGRATION_STATUSES } from '@/lib/consts.js'
import { COMPANIES_WITH_DISABLED_BUTTON } from './consts.js'
import { useCore } from '@/composables/core'

export function usePartnerApps () {
  const { t, router, store } = useCore()

  const business = store.state.business.business

  const isPartnerAppsEnabled = computed(() => {
    return !!business.partner_apps_enabled
  })

  const getPartner = (partnerType) => {
    return business.partner_apps?.find(p => p.application_client_id === partnerType)
  }

  const getPartnerStatus = (partnerType) => {
    const partner = getPartner(partnerType)
    return partner?.status
  }

  const isPartnerEnabled = (partnerType) => {
    return isPartnerAppsEnabled.value && is(Object, getPartner(partnerType))
  }

  const isPartnerStatus = (partnerType, status) => {
    if (!isPartnerAppsEnabled.value) return false
    return getPartnerStatus(partnerType) === status
  }

  const isPartnerSuspended = (partnerType) => {
    return isPartnerStatus(partnerType, PARTNER_APP_INTEGRATION_STATUSES.SUSPENDED)
  }

  const isPartnerBlocked = (partnerType) => {
    return isPartnerStatus(partnerType, PARTNER_APP_INTEGRATION_STATUSES.BLOCKED)
  }

  const isPartnerDisabled = (partnerType) => {
    return isPartnerStatus(partnerType, PARTNER_APP_INTEGRATION_STATUSES.DISABLED)
  }
  const canPartnerAppBeDisabled = (partnerType) => {
    const partner = getPartner(partnerType)
    const isDisabled = !!COMPANIES_WITH_DISABLED_BUTTON.find((elem) => {
      return elem === partner.company_name
    })

    return !isDisabled
  }
  const getPartnerStatusLabel = (partnerType) => {
    const status = isPartnerStatus(partnerType)
    if (status === PARTNER_APP_INTEGRATION_STATUSES.ACTIVE) {
      return t('views.business.partner-app.status.active')
    }
    if (status === PARTNER_APP_INTEGRATION_STATUSES.BLOCKED) {
      return t('views.business.partner-app.status.blocked')
    }
    if (status === PARTNER_APP_INTEGRATION_STATUSES.PAID) {
      return t('views.business.partner-app.status.paid')
    }
    if (status === PARTNER_APP_INTEGRATION_STATUSES.SUSPENDED) {
      return t('views.business.partner-app.status.suspended')
    }
    if (status === PARTNER_APP_INTEGRATION_STATUSES.DISABLED) {
      return t('views.business.partner-app.status.disabled')
    }
    return ''
  }

  const getCallToActionLabel = (partnerType, callToActionName) => {
    const partner = getPartner(partnerType)
    return partner?.application_config?.call_to_actions?.[callToActionName]
  }

  const partnerAppAction = (
    partnerType,
    callToActionName,
    callToActionId,
    showSettingsMode
  ) => {
    router.push({
      name: showSettingsMode ? 'settings-partner-app' : 'partner-app',
      params: {
        partnerType,
        callToActionName,
        callToActionId,
      },
    })
  }

  const buySubscriptionRedirect = () => {
    router.push({
      name: 'settings.subscription.your-subscription',
    })
  }

  return {
    PARTNER_APP_INTEGRATION_STATUSES,
    isPartnerAppsEnabled,
    isPartnerEnabled,
    getPartner,
    getPartnerStatus,
    getPartnerStatusLabel,
    isPartnerSuspended,
    isPartnerBlocked,
    isPartnerDisabled,
    getCallToActionLabel,
    partnerAppAction,
    canPartnerAppBeDisabled,
    buySubscriptionRedirect,
  }
}
